(function attachElaDeliveryRules(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ElaDeliveryRules = api;
})(typeof window !== 'undefined' ? window : undefined, function createElaDeliveryRules() {
  'use strict';

  var RULES = {
    contract_version: 'ela-delivery-october-2026-v2',
    timezone: 'Asia/Kolkata',
    currency: 'INR',
    cutoff_boundary: 'unspecified_at_exact_time',
    eligibility_policy: {
      mode: 'approved_pincodes',
      source_document: 'Ela_Study_Delivery.pdf',
      confirmed_at: '2026-10-01T16:23:00+05:30',
      distance_geofence_enforced: false,
      fee_basis: 'measured_distance_charge_bands_not_pincode'
    },
    districts: {
      kochi: {
        source_district_label: 'Ernakulam', delivery_weekday: 'tuesday', capacity_boxes_per_week: 120,
        farm_origin: {
          provenance: 'user_confirmed',
          maps_url: 'https://maps.app.goo.gl/sR2KukdhveEMTQHr8',
          coordinates: null
        },
        distance_context: {
          reported_maximum_km: 25,
          provenance: 'user_reported_2026-10-01T12:27:00+05:30',
          used_for_eligibility: false,
          note: 'Operational context only; excluded areas can exist inside this distance.'
        },
        serviceability_limit: 'listed_pincodes_only',
        four_delivery_charge_bands: [
          ['0 - 5', 0, 5, true, true, 260], ['6 - 10', 6, 10, true, true, 360],
          ['11 - 15', 11, 15, true, true, 460], ['16 - 20', 16, 20, true, true, 520],
          ['>20', 20, null, false, false, 580]
        ]
      },
      kottayam: {
        source_district_label: 'Kottayam', delivery_weekday: 'wednesday', capacity_boxes_per_week: 35,
        farm_origin: {
          provenance: 'user_confirmed',
          maps_url: 'https://maps.app.goo.gl/qE7BimW4HeqibTmf9',
          coordinates: null
        },
        distance_context: {
          reported_maximum_km: 30,
          provenance: 'Ela_Study_Delivery.pdf',
          used_for_eligibility: false
        },
        serviceability_limit: 'listed_pincodes_only',
        four_delivery_charge_bands: [
          ['0 - 4', 0, 4, true, true, 225], ['4 - 6', 4, 6, true, true, 260],
          ['6 - 8', 6, 8, true, true, 345], ['8 - 10', 8, 10, true, true, 380],
          ['10 - 12', 10, 12, true, true, 415], ['12 - 14', 12, 14, true, true, 445],
          ['14 - 16', 14, 16, true, true, 475], ['16 - 18', 16, 18, true, true, 510],
          ['18 - 20', 18, 20, true, true, 545], ['20 - 22', 20, 22, true, true, 565],
          ['22 - 24', 22, 24, true, true, 575], ['24 - 26', 24, 26, true, true, 585],
          ['26 - 28', 26, 28, true, true, 595], ['28 - 30', 28, 30, true, true, 600]
        ]
      },
      thrissur: {
        source_district_label: 'Thrissur', delivery_weekday: 'wednesday', capacity_boxes_per_week: 40,
        farm_origin: {
          provenance: 'user_confirmed',
          maps_url: 'https://maps.app.goo.gl/5sHfZvhUtfP3YcGL6?g_st=ac',
          coordinates: null
        },
        distance_context: {
          reported_maximum_km: 22,
          provenance: 'Ela_Study_Delivery.pdf',
          used_for_eligibility: false
        },
        serviceability_limit: 'listed_pincodes_only',
        four_delivery_charge_bands: [
          ['0 - 4', 0, 4, true, true, 245], ['4 - 6', 4, 6, true, true, 265],
          ['6 - 8', 6, 8, true, true, 335], ['8 - 10', 8, 10, true, true, 360],
          ['10 - 12', 10, 12, true, true, 375], ['12 - 14', 12, 14, true, true, 395],
          ['14 - 16', 14, 16, true, true, 415], ['16 - 18', 16, 18, true, true, 465],
          ['18 - 20', 18, 20, true, true, 485], ['>20', 20, null, false, false, 520]
        ]
      }
    },
    pincode_to_district: {
      '682001':'kochi','682002':'kochi','682005':'kochi','682006':'kochi','682008':'kochi','682011':'kochi',
      '682013':'kochi','682015':'kochi','682016':'kochi','682017':'kochi','682018':'kochi','682019':'kochi',
      '682020':'kochi','682021':'kochi','682022':'kochi','682024':'kochi','682025':'kochi','682026':'kochi',
      '682030':'kochi','682031':'kochi','682033':'kochi','682035':'kochi','682036':'kochi','682037':'kochi',
      '682301':'kochi','682304':'kochi','682305':'kochi','682306':'kochi','683101':'kochi','683104':'kochi',
      '683503':'kochi','683512':'kochi','683513':'kochi',
      '686008':'kottayam','686015':'kottayam','686016':'kottayam','686101':'kottayam','686102':'kottayam',
      '686531':'kottayam','686535':'kottayam','686561':'kottayam','686562':'kottayam','686563':'kottayam',
      '686572':'kottayam','686575':'kottayam','686577':'kottayam','686578':'kottayam','686631':'kottayam',
      '686632':'kottayam','686633':'kottayam','686636':'kottayam','689101':'kottayam','689102':'kottayam',
      '689103':'kottayam',
      '680001':'thrissur','680002':'thrissur','680003':'thrissur','680004':'thrissur','680006':'thrissur',
      '680007':'thrissur','680009':'thrissur','680010':'thrissur','680011':'thrissur','680014':'thrissur',
      '680015':'thrissur','680020':'thrissur','680021':'thrissur','680026':'thrissur','680631':'thrissur',
      '680651':'thrissur'
    },
    schedule: [
      [1, '2026-10-05T11:00:00+05:30', '2026-10-06', '2026-10-07', '2026-10-07'],
      [2, '2026-10-12T11:00:00+05:30', '2026-10-13', '2026-10-14', '2026-10-14'],
      [3, '2026-10-19T11:00:00+05:30', '2026-10-20', '2026-10-21', '2026-10-21'],
      [4, '2026-10-26T11:00:00+05:30', '2026-10-27', '2026-10-28', '2026-10-28']
    ],
    fee_policies: {
      sample: { delivery_count: 1, status: 'confirmed', fee_inr: 0 },
      two_deliveries: { delivery_count: 2, status: 'needs_confirmation', reason: 'source_does_not_supply_two_delivery_fee_formula' },
      four_deliveries: { delivery_count: 4, status: 'confirmed', charge_basis: 'total_for_four_deliveries' }
    }
  };

  function expandBand(band) {
    return {
      source_range: band[0], min_km: band[1], max_km: band[2],
      min_inclusive: band[3], max_inclusive: band[4], fee_inr: band[5]
    };
  }

  Object.keys(RULES.districts).forEach(function (district) {
    RULES.districts[district].four_delivery_charge_bands =
      RULES.districts[district].four_delivery_charge_bands.map(expandBand);
  });
  RULES.schedule = RULES.schedule.map(function (row) {
    return {
      week: row[0], cutoff_at: row[1],
      delivery_dates: { kochi: row[2], kottayam: row[3], thrissur: row[4] }
    };
  });

  function deepFreeze(value) {
    if (!value || typeof value !== 'object' || Object.isFrozen(value)) return value;
    Object.keys(value).forEach(function (key) { deepFreeze(value[key]); });
    return Object.freeze(value);
  }

  function normalizePincode(value) {
    var pincode = String(value == null ? '' : value).trim();
    return /^\d{6}$/.test(pincode) ? pincode : null;
  }

  function findDistrict(pincode, rules) {
    var activeRules = rules || RULES;
    var normalized = normalizePincode(pincode);
    if (!normalized) return { status: 'invalid_input', reason: 'pincode_must_be_six_digits' };
    var district = activeRules.pincode_to_district[normalized];
    if (!district) return { status: 'ineligible', reason: 'pincode_not_listed', pincode: normalized };
    return { status: 'eligible', pincode: normalized, district: district };
  }

  function parseInstant(value) {
    if (value instanceof Date) return Number.isFinite(value.getTime()) ? value.getTime() : null;
    if (typeof value !== 'string' || !/(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return null;
    var instant = Date.parse(value);
    return Number.isFinite(instant) ? instant : null;
  }

  var ROLLING_HORIZON_WEEKS = 12;
  var DAY_MS = 86400000;

  function shiftDate(isoDate, days) {
    var d = new Date(isoDate + 'T00:00:00Z');
    d.setUTCDate(d.getUTCDate() + days);
    return d.toISOString().slice(0, 10);
  }

  // The supplied calendar covers October only. Later weeks repeat its own
  // pattern exactly (cutoff Monday 11:00 IST; Kochi Tuesday, Kottayam and
  // Thrissur Wednesday), marked `rolling_weekly_pattern` so operations can tell
  // them from the supplied rows and override them with real dates.
  function expandSchedule(schedule, orderedAt) {
    var rows = schedule.map(function (entry) {
      return { week: entry.week, cutoff_at: entry.cutoff_at, delivery_dates: entry.delivery_dates, source: 'supplied' };
    });
    if (!rows.length) return rows;
    var horizon = orderedAt + ROLLING_HORIZON_WEEKS * 7 * DAY_MS;
    var last = rows[rows.length - 1];
    while (Date.parse(last.cutoff_at) < horizon) {
      var cutoffDate = shiftDate(last.cutoff_at.slice(0, 10), 7);
      var next = {
        week: last.week + 1,
        cutoff_at: cutoffDate + last.cutoff_at.slice(10),
        delivery_dates: {},
        source: 'rolling_weekly_pattern'
      };
      Object.keys(last.delivery_dates).forEach(function (district) {
        next.delivery_dates[district] = shiftDate(last.delivery_dates[district], 7);
      });
      rows.push(next);
      last = next;
    }
    return rows;
  }

  function selectDeliveryDates(input, rules) {
    var activeRules = rules || RULES;
    var location = findDistrict(input && input.pincode, activeRules);
    if (location.status !== 'eligible') return location;
    var orderedAt = parseInstant(input && input.orderedAt);
    if (orderedAt === null) return { status: 'invalid_input', reason: 'orderedAt_requires_iso_offset_or_date' };
    var requested = input && input.deliveryCount;
    if (requested != null && (!Number.isInteger(requested) || requested < 1)) {
      return { status: 'invalid_input', reason: 'deliveryCount_must_be_positive_integer' };
    }

    var options = expandSchedule(activeRules.schedule, orderedAt).map(function (entry) {
      var cutoff = Date.parse(entry.cutoff_at);
      var cutoffStatus = orderedAt < cutoff ? 'open' : orderedAt > cutoff ? 'closed' : 'boundary_needs_confirmation';
      return {
        week: entry.week,
        delivery_date: entry.delivery_dates[location.district],
        cutoff_at: entry.cutoff_at,
        cutoff_status: cutoffStatus,
        source: entry.source
      };
    });
    var boundary = options.filter(function (option) { return option.cutoff_status === 'boundary_needs_confirmation'; });
    var open = options.filter(function (option) { return option.cutoff_status === 'open'; });

    if (boundary.length) {
      return {
        status: 'needs_confirmation', reason: 'exact_cutoff_boundary_unspecified',
        district: location.district, options: options, selected_dates: []
      };
    }
    if (requested != null && open.length < requested) {
      return {
        status: 'unavailable', reason: 'insufficient_open_october_delivery_dates',
        district: location.district, options: options, selected_dates: []
      };
    }
    return {
      status: open.length ? 'ok' : 'unavailable',
      reason: open.length ? null : 'all_october_cutoffs_closed',
      district: location.district,
      options: options,
      selected_dates: requested == null ? open.map(function (option) { return option.delivery_date; }) :
        open.slice(0, requested).map(function (option) { return option.delivery_date; })
    };
  }

  function matchesBand(distance, band) {
    var aboveMin = band.min_inclusive ? distance >= band.min_km : distance > band.min_km;
    var belowMax = band.max_km === null || (band.max_inclusive ? distance <= band.max_km : distance < band.max_km);
    return aboveMin && belowMax;
  }

  function calculateDeliveryFee(input, rules) {
    var activeRules = rules || RULES;
    if (!input || input.pincode == null) {
      return { status: 'invalid_input', reason: 'serviceable_pincode_required' };
    }
    var location = findDistrict(input.pincode, activeRules);
    if (location.status !== 'eligible') return location;
    if (input.district && input.district !== location.district) {
      return { status: 'invalid_input', reason: 'district_does_not_match_pincode' };
    }
    if (input && input.planType === 'sample') {
      return {
        status: 'ok', fee_inr: 0, charge_basis: 'sample_no_delivery_charge',
        district: location.district
      };
    }
    if (!input || input.deliveryCount === 2) {
      return { status: 'needs_confirmation', reason: 'source_does_not_supply_two_delivery_fee_formula' };
    }
    if (input.deliveryCount !== 4) {
      return { status: 'needs_confirmation', reason: 'delivery_count_fee_policy_not_confirmed' };
    }

    if (input.distanceKm == null) {
      return {
        status: 'needs_confirmation', reason: 'measured_distance_required_no_coordinates_supplied',
        district: location.district
      };
    }
    var distance = Number(input.distanceKm);
    if (!Number.isFinite(distance) || distance < 0) {
      return { status: 'invalid_input', reason: 'distanceKm_must_be_non_negative_number' };
    }

    var districtRules = activeRules.districts[location.district];
    var matches = districtRules.four_delivery_charge_bands.filter(function (band) {
      return matchesBand(distance, band);
    });
    if (matches.length === 0) {
      return {
        status: 'needs_confirmation', reason: 'distance_between_source_bands',
        district: location.district, distance_km: distance
      };
    }
    if (matches.length > 1) {
      return {
        status: 'needs_confirmation', reason: 'distance_matches_multiple_source_bands',
        district: location.district, distance_km: distance,
        source_ranges: matches.map(function (band) { return band.source_range; })
      };
    }
    return {
      status: 'ok', district: location.district, distance_km: distance,
      delivery_count: 4, fee_inr: matches[0].fee_inr,
      charge_basis: 'total_for_four_deliveries', source_range: matches[0].source_range
    };
  }

  deepFreeze(RULES);
  return deepFreeze({
    rules: RULES,
    normalizePincode: normalizePincode,
    findDistrict: findDistrict,
    selectDeliveryDates: selectDeliveryDates,
    calculateDeliveryFee: calculateDeliveryFee
  });
});
